import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const infoStyle = css`
  vertical-align: middle;

  &:focus {
    outline: none;
  }

  svg {
    transition: fill 200ms ease-in-out;
  }

  &:hover svg,
  &:focus svg {
    fill: ${theme.colors.primary50};
  }
`;
